<template>

  <section class="hero">
    <h1 class="hero__title">Claudia <br>De Medio</h1>
    <h2 v-if="!dark" class="hero__subtitle">Visual &amp; Product<br>Designer</h2>
    <a v-if="dark" class="hero__email" href="mailto:claudiademedio@gmail.com">claudiademedio@gmail.com</a>
    <div v-if="dark" class="hero__telephone">+34 696 344 016</div>
    <div v-if="dark" class="hero__social">
      <a target="_blank" href="https://it.linkedin.com/in/claudia-de-medio-69745964" class="hero__social__icon hero__social__icon--linkedin"></a>
      <a target="_blank" href="https://www.pinterest.it/claudiademedio/" class="hero__social__icon hero__social__icon--pinterest"></a>
      <a target="_blank" href="https://www.behance.net/ClaudiaDeMedio" class="hero__social__icon hero__social__icon--behance"></a>
    </div>
    <div v-if="dark" class="hero__made">
      Code with ❤️ and 🔥 by <a href="https://www.linkedin.com/in/emanuelemacri/" title="Emanuele Macri's Linkedin" target="_blank">Emanuele Macri</a>
    </div>
    <div v-if="image" class="hero__portrait">
      <img alt="Claudia De Medio" src="../assets/portrait.png">
    </div>
    <div v-if="!image && !dark" class="hero__scroller" @click="scrollToPortfolio()">This way for Portfolio</div>
  </section>

</template>

<script>

  export default {
    name: 'Hero',
    props: {
      image: {
        type: Boolean,
        default: false
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      scrollToPortfolio() {
        document.querySelector('.list').scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .hero {
    @include container;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 70px;
    padding-bottom: 20px;
    margin-bottom: 40px;

    @include mq(small) {
      height: 90vh;
      justify-content: center;
      padding-top: 90px;
    }

    .portfolio & {
      height: calc(100vh - 180px); 
      justify-content: flex-start;

      @include mq(small) {
        height: 90vh;
        justify-content: flex-end;
        padding-top: 90px;
      }
    }   
  }

  .hero__title {
    @include outline;
    margin-bottom: 20px;
    z-index: 1;

    br {
      display: none;

      @include mq(small) {
        display: block;
      }
    }
  }

  .hero__subtitle {
    @include title;
    margin-bottom: 110px;
    
    @include mq(small) {
      margin-bottom: 50px;
    }
  }

  .hero__email {
    @include title;
    margin-bottom: 5px;

    @include mq(small) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .hero__telephone {
    @include title;
    margin-bottom: 40px;

    @include mq(small) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .hero__social {
    display: flex;
    justify-content: flex-start;
  }

  .hero__social__icon {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 40px;

    &.hero__social__icon--linkedin {
      background: url('../assets/icon-linkedin.svg') 50% 50% no-repeat;
    }

    &.hero__social__icon--pinterest {
      background: url('../assets/icon-pinterest.svg') 50% 50% no-repeat;
    }

    &.hero__social__icon--behance {
      background: url('../assets/icon-behance.svg') 50% 50% no-repeat;
    }
  }

  .hero__made {
    color: $white;
    padding-top: 45px;

    span {
      color: $dark;
    }

    a {
      color: $white;
    }
  }

  .hero__portrait {
    position: absolute;
    top: 50px;
    right: 70px;

    @include mq(small) {
      display: none;
    }

    &:before {
      content: '';
      position: absolute;
      width: 90px;
      height: 90px;
      border-radius: 50%;
      background-color: $dark;
      top: -40px;
      right: -50px;
      z-index: -1;
    }
  }

  .hero__scroller {
    @include current(small);
    cursor: pointer; 
    line-height: 40px;
    padding-bottom: 10px;
    padding-left: 60px;
    padding-top: 10px;
    position: relative;

    &:before {

      @keyframes scrollAnimation {
        0%, 100% {
          top: 0px;
        }

        50% {
          top: 20px;
        }
      }

      content: '';
      position: absolute;
      left: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      top: 0px;
      background: url('../assets/arrow.svg') 50% 50% no-repeat $dark;
      animation: scrollAnimation 2s ease-in-out infinite;
    }

    .portfolio & {
      position: absolute;
      bottom: 0;
      left: 0;

      @include mq(small) {
        position: relative;
      }
    }
  }

</style>
